/**
 * Client-side in-memory course cache.
 * Avoids redundant API calls when navigating between pages.
 * TTL: 2 minutes (server cache is 5 min, so this stays fresh enough).
 */

const CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutes
const store = new Map();

export function getCachedCourses(key) {
  const entry = store.get(key);
  if (!entry) return null;
  if (Date.now() - entry.ts > CACHE_TTL_MS) {
    store.delete(key);
    return null;
  }
  return entry.data;
}

export function setCachedCourses(key, data) {
  store.set(key, { data, ts: Date.now() });
}

export function clearCourseCache() {
  store.clear();
}
